import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"

export const autoEuropeDrawerData = signal({})
export const autoEuropeDrawerErrors = signal({})
export const autoEuropeListData = signal([])
export const autoEuropeStatusFilter = signal(['Enabled'])
export const autoEuropeIsLoading = signal(false)
export const autoEuropeIsSubmitting = signal(false)
export const autoEuropeOriginalData = signal(null)
// { [id]: name } — populated when SeasonSetField loads its options
export const autoEuropeSeasonSetsMap = signal({})

export const isAutoEuropeDrawerOpen = computed(() => autoEuropeDrawerData.value && !isEmpty(autoEuropeDrawerData.value))

export const clearAutoEuropeSignals = () => batch(() => {
	autoEuropeDrawerData.value = {}
	autoEuropeDrawerErrors.value = {}
	autoEuropeOriginalData.value = null
})
